module.exports = __webpack_public_path__ + "static/media/48372551_2309078395834005_7750254153326133248_o-thumb.5cfdfc96.jpg";